import { NgModule, ErrorHandler, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { AppSelectionComponent } from './components/app-selection/app-selection.component';
import { SelectModule } from 'primeng/select';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthInterceptor } from './interceptors/auth-interceptor';
import { ErrorInterceptor } from './interceptors/error-interceptor';
import { RequestInterceptor } from './interceptors/request-interceptor';
import { AutoFocusDirective } from './directives/auto-focus.directive';
import { HeaderComponent } from './components/header/header.component';
import { ModalDialogComponent } from './components/modal-dialog/modal-dialog.component';
import { AppConfigService } from './services/app-config.service';
import { MaintenaceModeComponent } from './components/maintenace-mode/maintenace-mode.component';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';

export function loadAppConfig(appConfigService: AppConfigService) {
  return () => appConfigService.loadAppConfig();
}

@NgModule({ declarations: [
        AppComponent,
        LoginComponent,
        AppSelectionComponent,
        MaintenaceModeComponent,
        AutoFocusDirective,
        HeaderComponent,
        ModalDialogComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        SelectModule,
        BrowserAnimationsModule,
        ProgressSpinnerModule], providers: [
        provideAppInitializer(() => {
        const initializerFn = (loadAppConfig)(inject(AppConfigService));
        return initializerFn();
      }),
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
        providePrimeNG({
          theme: {
            preset: Aura 
          }
        }),
        provideAppInitializer(() => {
      
      }),
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
